<template lang="pug">
  ul.TheFooterMenu.footer-menu
    li.footer-menu__item(
      v-for="child in children"
    )
      router-link.footer-menu__item-link.link-with-opacity(
        v-if="child.path.startsWith('/') && !child.newApp",
        :to="child.path",
      )
        span {{ child.name }}
      a.footer-menu__item-link.link-with-opacity(
        v-else-if="child.newApp",
        :href="child.path",
      )
        span {{ child.name }}
      a.footer-menu__item-link.link-with-opacity(
        v-else,
        :href="child.path",
        target="_blank",
      )
        span {{ child.name }}
</template>

<script>

export default {
  name: 'TheFooterMenu',
  props: {
    children: Array,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-menu
  list-style-type: none
  padding-left: 0
  margin-left: 0
  display: flex
  flex-direction: row
  justify-content: space-between
  flex-wrap: wrap
  &__item
    width: calc(50% - 46px)
    flex-shrink: 0
    margin-bottom: 20px
  &__item-link
    font-size: 14px
    line-height: 20px
    display: inline
    +font(600)
    +mt(.2s)
    &:active
      opacity: 0.5
</style>
